import { BaseTypeEnum } from 'src/app/product-capture/model/consts/participation-base-type.const';
import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import {
  PAYOFF_CALLABILITY_CALLABILITY,
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  PAYOFF_COUPON,
  PAYOFF_COUPON_REFERENCE_RATE,
  PAYOFF_COUPON_TYPE,
  PAYOFF_PARTICIPATION,
  PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_ALLOCATION,
  PAYOFF_PARTICIPATION_BASE_BARRIER_LEVELS_AND_INVESTMENTS,
  PAYOFF_PARTICIPATION_BASE_TYPE,
  PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE,
  PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
  PAYOFF_PARTICIPATION_BASE_INITIAL_CASH_ALLOCATION,
  PAYOFF_PARTICIPATION_BASE_INITIAL_INVESTMENT_ALLOCATION,
  PAYOFF_PARTICIPATION_UPSIDE_TYPE,
  SUMMARY_FREQUENCY,
  SUMMARY_PERFORMANCE_TYPE,
  SUMMARY_REFERENCE_ENTITIES,
  SUMMARY_SETTLEMENT_TYPE,
  SUMMARY_UNDERLYING_ASSETS_GROUP,
} from '../../mockups/consts/product-capture-field-selectors.consts';

export const CAPPED_FLOOR_DELTA_N_PRODUCT_SETTINGS = {
  id: ProductTypeEnum.CAPPED_FLOOR_DELTA_N,
  label: 'Capped Floor Delta N',
  effects: [
    {
      formControlNames: [
        SUMMARY_REFERENCE_ENTITIES,
        PAYOFF_COUPON_REFERENCE_RATE,
        PAYOFF_COUPON,
        PAYOFF_CALLABILITY_CALLABILITY,
        PAYOFF_PARTICIPATION,
        PAYOFF_PARTICIPATION_BASE_INITIAL_CASH_ALLOCATION,
        PAYOFF_PARTICIPATION_BASE_INITIAL_INVESTMENT_ALLOCATION,
        PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_ALLOCATION,
        PAYOFF_PARTICIPATION_BASE_BARRIER_LEVELS_AND_INVESTMENTS,
      ],
      hidden: true,
    },
    {
      formControlNames: [SUMMARY_UNDERLYING_ASSETS_GROUP],
      hidden: false,
    },
    {
      formControlNames: [
        PAYOFF_COUPON_TYPE,
        PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
        PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
        PAYOFF_PARTICIPATION_UPSIDE_TYPE,
        PAYOFF_PARTICIPATION_BASE_TYPE,
        PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE,
      ],
      selectValues: ['NONE'],
      hidden: true,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_BASE_TYPE],
      selectValues: [BaseTypeEnum.DELTA_N],
      hidden: false,
    },
    {
      formControlNames: [
        SUMMARY_FREQUENCY,
        SUMMARY_PERFORMANCE_TYPE,
        SUMMARY_SETTLEMENT_TYPE,
      ],
      readOnly: false,
    },
  ],
};
